<template>
  <div class="small-table-container">
    <table class="small-table">
        <thead>
            <tr>
                <th :class="{'user-col-with': !canSeeExpense || !canSeeBillable}">
                    <span>User</span>
                </th>
                <th v-if="canSeeExpense" class="small-table__time col">
                    <div class="small-table__flex-item exp">
                        <span>Exp</span>
                        <i class="icon-question-mark">

                            <Tooltip
                                position="right"
                            >
                                <div class="tooltip__label">Expenses for this task</div>
                            </Tooltip>
                        </i>
                    </div>
                </th>
                <th v-if="canSeeBillable" class="small-table__time">
                    <div class="small-table__flex-item">
                        <span>Bill</span>
                        <i class="icon-question-mark">
                            <Tooltip
                                position="right"
                            >
                                <div class="tooltip__label">Billable for this task</div>
                            </Tooltip>
                        </i>
                    </div>
                </th>
                <th class="small-table__time">
                    <span>Time</span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                class="small-table__body"
                v-for="(event, e) in loggedWorkEvents"
                :key="`event-${e}`"
            >
                <td>
                    <div class="flex-gap-9">
                        <UserAvatar
                            :user="event.user"
                            size="medium"
                        ></UserAvatar>
                        <span class="username">{{ event.user.username }}</span>
                    </div>
                </td>
                <td v-if="canSeeExpense">
                    <button class="show-price" @click="event.isExpensesVisible = !event.isExpensesVisible">
                        <span class="price-text" v-if="event.isExpensesVisible">
                            {{ taskTimeTracker[event.user.id].total_expense / 100 }}
                        </span>
                        <i :class="{'icon-view' : !event.isExpensesVisible}"></i>
                    </button>
                </td>
                <td v-if="canSeeBillable">
                    <button class="show-price" @click="event.isBillableVisible = !event.isBillableVisible">
                        <span class="price-text" v-if="event.isBillableVisible">
                            {{ taskTimeTracker[event.user.id].total_billable / 100 }}
                        </span>
                        <i :class="{'icon-view' : !event.isBillableVisible}"></i>
                    </button>
                </td>
                
                <td><span style="white-space: nowrap;">{{ convertTimeToHMSystem(event.body.minutes) }}</span></td>
            </tr>
            <tr class="small-table__total-time">
                <td>Total</td>
                <td v-if="canSeeExpense"></td>
                <td v-if="canSeeBillable"></td>
                <td><span style="white-space: nowrap;">{{ convertTimeToHMSystem(totaltime) }}</span></td>
            </tr>
        </tbody>
    </table>
  </div>
</template>
<script>
  import UserAvatar from "@/components/atoms/UserAvatar.vue";
  import { mapState } from 'vuex';
  import Tooltip from "@/components/atoms/Tooltip.vue";

  export default {
    name: "TimeTrackerSmall",
    props: ["events", "tags"],
    components: {
        UserAvatar,
        Tooltip
    },
    data() {
        return {
            loggedWorkEvents: [],
            totaltime: 0
        }
    },
    mounted() {
        if (this.events && this.events.length > 0) {
            this.getCorrectTime(this.events)
        }
    },
    computed: {
        ...mapState(['taskTimeTracker']),
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        canSeeExpense() {
            return (this.activeBoard.yourPerms.includes('admin') ||
                   this.activeBoard.yourPerms.includes('owner') ||
                   this.activeBoard.yourPerms.includes('see_expense')) &&
                   this.taskTimeTracker && Object.keys(this.taskTimeTracker).length > 0
        },
        canSeeBillable() {
            return (this.activeBoard.yourPerms.includes('admin') ||
                   this.activeBoard.yourPerms.includes('owner') ||
                   this.activeBoard.yourPerms.includes('see_billable')) &&
                   this.taskTimeTracker && Object.keys(this.taskTimeTracker).length > 0
        }
    },
    watch: {
        events: {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    this.getCorrectTime(newVal)
                }
            },
            deep: true
        }
    },
    methods: {
        convertTimeToHMSystem(min, unit) {
            const decimalHours = min / 60;
            const hours = Math.floor(decimalHours);
            const minutes = min % 60;

            if (unit === 'm') {
                return minutes;
            } else if (unit === 'h') {
                return hours;
            } else {
                return `${hours}h ${minutes}m`;
            }
        },
        getCorrectTime(events) {
            const mergedData = {};
            events.forEach(item => {
                if (item.type === 'logwork') {
                    const userId = item.user_id;
                    if (!mergedData[userId]) {
                        mergedData[userId] = {
                            isBillableVisible: false,
                            isExpensesVisible: false,
                            name: item.type,
                            body: { minutes: item.uint1, notes: item.txt1 },
                            user: { id: item.user_id, username: this.getEventUser(item)['username'], email: this.getEventUser(item)['email'], portrait: this.getEventUser(item)['portrait'] },
                        };
                    } else {
                        mergedData[userId].body.minutes += item.uint1;
                    }
                }
            });
            this.loggedWorkEvents = Object.values(mergedData);

            this.totaltime = this.loggedWorkEvents.reduce((a, b) => a + b.body.minutes, 0)
        },
        getEventUser(event) {
            return this.tags?.find(t => t.id == event.user_id) || {}
        },
        toggleBillable(id) {
            this.taskTimeTracker
        }
    }
  }
</script>
<style scoped lang="scss">
    .small-table-container {
        border-radius: 6px;
        background-color: var(--primary-bg);
        border: 0.5px solid var(--outline);
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
    }

    .small-table {
        width: 100%;
        table-layout: fixed;

        &__flex-item {
            display: flex;
            align-items: center;
            gap: 3px;
        }

        thead {
            th:first-child {
                width: 43%;
                padding: 5px 0 5px 10px;
                border-radius: 6px 0 0;
                font-weight: 500;
                span {
                    padding: 5px 10px;
                }
            }
            th:last-child {
                border-radius: 0 6px 0 0;
            }
        }

        .username {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        &__time {
            text-align: start;
            padding: 10px 0;
            font-weight: 500;
            width: 13%;
            span {
                padding: 5px 0 5px 5px;
            }

            .icon-question-mark::before {
                font-size: 11px;
            }

            i {
                position: relative;
                top: -1px;
            }
            .exp {
                span {
                    border-left: none;
                }
            }
            .tooltip-container.right{
                top: 25px;
            }
            &:last-child {
                width: 21%;
            }
        }

        &__total-time td {
            padding-top: 10px;
            padding-bottom: 5px;
            font-weight: 500;
            border-top: 0.5px solid var(--outline);
            &:first-child {
                border-radius: 0 0 0 6px;
            }
            &:last-child {
                border-radius: 0 0 6px 0;
            }
        }

        &__body {
            .flex-gap-9 {
                overflow-wrap: anywhere;
            }
        }

        tbody {
            td {
                font-weight: 300;
                padding: 5px;
                position: relative;
                isolation: isolate;
                &:first-of-type {
                    padding-left: 15px;
                }
                &:last-of-type {
                    padding-right: 15px;
                }
            }
            
        }

        thead {
            border-bottom: 0.5px solid var(--outline);
        }

        tbody td:first-child {
            padding-left: 15px;
        }

        tbody td:not(:first-child) {
            text-align: center;
        }
    }
    .time {
        border-radius: 0 6px 0 0;
        width: 74px;
        span {
            padding-left: 20px;
        }
    }

    .user-col-with {
        width: 77% !important;
    }

    .show-price {
        color: $gray-1;
    }
</style>